module.exports = __webpack_public_path__ + "img/gamesdk20.6772993.png";